import { Component, OnInit } from '@angular/core';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ThemeService } from 'src/app/theme/theme-service.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { EmailTemplateDataService } from 'src/app/services/email-template-data.service';

@Component({
  selector: 'app-upload-professionals-list',
  templateUrl: './upload-professionals-list.component.html',
  styleUrls: ['./upload-professionals-list.component.scss'],
})
export class UploadProfessionalsListComponent implements OnInit {
  public activeTheme: any;
  public data: any[] = [];
  public clientsUploaded: boolean = false;
  public editingRowIndex: number | null = null;
  public invalidEmails: number[] = [];

  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService,
    private router: Router,
    private emailTemplateDataService: EmailTemplateDataService
  ) {}

  ngOnInit(): void {
    this.activeTheme = this.themeService.active;
  }

  downloadTemplate() {
    const templateUrl = '../../../assets/doc/Template - Upload Professionals List.xlsx';
    const fileName = 'Template - Upload Professionals List.xlsx';

    fetch(templateUrl)
      .then((response) => response.blob())
      .then((blob) => saveAs(blob, fileName))
      .catch((error) => console.error('Error downloading the file:', error));
  }

  onFileChange(evt: any) {
    this.clientsUploaded = true;
    const target: DataTransfer = <DataTransfer>evt.target;
  
    if (target.files.length !== 1) {
      throw new Error('Cannot upload multiple files at the same time.');
    }
  
    const reader: FileReader = new FileReader();
  
    reader.onload = (e: any) => {
      const binaryStr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(binaryStr, { type: 'binary' });
  
      const worksheet: XLSX.WorkSheet = workbook.Sheets[workbook.SheetNames[0]];
  
      const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  
      // Normalize header
      const header = (rawData.shift() as string[]).map((columnName: string) =>
        this.normalizeColumnName(columnName)
      );
  
      this.data = rawData
        .map((row: any[]) => {
          const mappedRow: any = {};
  
          header.forEach((columnName: string, index: number) => {
            if (columnName === 'firstname') {
              mappedRow.firstName = row[index];
            } else if (columnName === 'lastname') {
              mappedRow.lastName = row[index];
            } else if (columnName === 'email') {
              mappedRow.email = row[index];
            }
          });
  
          return mappedRow;
        })
        .filter((row: any) => row.firstName && row.lastName && row.email);
  
      this.checkInvalidEmails();
    };
  
    reader.readAsBinaryString(target.files[0]);
  }

  normalizeColumnName(columnName: string): string {
    return columnName.toLowerCase().replace(/\s+/g, '');
  }

  editRow(index: number) {
    this.editingRowIndex = index;
  }

  saveRow(index: number, emailForm: NgForm) {
    const emailInput = emailForm.controls[`email_${index}`];
  
    if (emailInput && emailInput.invalid) {
      alert('Please enter a valid email.');
      return;
    }
  
    const email = this.data[index].email;
    if (!this.isValidEmail(email)) {
      alert('Please enter a valid email.');
      return;
    }
  
    this.editingRowIndex = null;
  
    if (this.invalidEmails.includes(index) && this.isValidEmail(email)) {
      const invalidIndex = this.invalidEmails.indexOf(index);
      this.invalidEmails.splice(invalidIndex, 1);
    }
  }

  cancelEdit() {
    if (this.editingRowIndex !== null) {
      const email = this.data[this.editingRowIndex].email;
      if (!this.isValidEmail(email)) {
        alert('Please enter a valid email.');
        return;
      }
    }
    this.editingRowIndex = null;
  }

  deleteRow(index: number) {
    this.data.splice(index, 1);
    if (this.data.length === 0) {
      this.clientsUploaded = false;
      console.log('All rows have been deleted.');
    }
  }

  redirectToEmailTemplate() {
    console.log('data: ', this.data);
    const invalidEmails = this.data
      .map((row, index) => (this.isValidEmail(row.email) ? -1 : index))
      .filter((index) => index !== -1);

    if (invalidEmails.length > 0) {
      alert('Please enter valid emails before continuing.');
      return;
    }

    this.emailTemplateDataService.setData(this.data);
    this.router.navigate(['/email-template']);
  }

  isValidEmail(email: string): boolean {
    // Basic email validation using a regular expression
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  }

  checkInvalidEmails() {
    this.invalidEmails = this.data
      .map((row, index) => (this.isValidEmail(row.email) ? -1 : index))
      .filter((index) => index !== -1);
  }
}
